// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1m-e";
export var animationRelative = "_1m-d";
export var backdropBlur = "_1m-0";
export var detailLabelCell = "_1m-q";
export var detailTable = "_1m-p";
export var detailValueCell = "_1m-r";
export var documentTypeIcon = "_1m-y";
export var documentTypeOption = "_1m-x";
export var dropdownMatchDatePicker = "_1m-3";
export var evidenceCardContent = "_1m-w";
export var gorgiasTicketCard = "_1m-s";
export var iconTertiary = "_1m-z";
export var integrationCard = "_1m-1";
export var integrationLogoBox = "_1m-2";
export var mainColumnSticky = "_1m-v";
export var maxWidthContainer = "_1m-t";
export var modalContentBody = "_1m-a";
export var modalHeaderImage = "_1m-5";
export var modalImageLabel = "_1m-7";
export var modalImageOverlay = "_1m-6";
export var modalImageSubtitle = "_1m-9";
export var modalImageTitle = "_1m-8";
export var modalImageWrapper = "_1m-4";
export var modalStickyFooter = "_1m-b";
export var sidebarColumn = "_1m-u";
export var timelineLine = "_1m-m";
export var timelineLineBlack = "_1m-o _1m-m";
export var timelineLineGray = "_1m-n _1m-m";
export var timelineLineHeight = "_1m-l";
export var tlDotActivate = "_1m-i";
export var tlDotActivateAnim = "_1m-h";
export var tlDotHide = "_1m-g";
export var tlDotHideAnim = "_1m-f";
export var tlLineActivate = "_1m-k";
export var tlLineActivateAnim = "_1m-j";
export var uploadedFileRow = "_1m-c";